import { render, staticRenderFns } from "./AnalyticsChipWrapper.vue?vue&type=template&id=1a8bbd3e&scoped=true"
import script from "./AnalyticsChipWrapper.vue?vue&type=script&lang=js"
export * from "./AnalyticsChipWrapper.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsChipWrapper.vue?vue&type=style&index=0&id=1a8bbd3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8bbd3e",
  null
  
)

export default component.exports